import {selectManyByPredicate, UIEntitiesRef} from '@ngneat/elf-entities';
import {select} from '@ngneat/elf';

import {suppliersServicesStore} from '@store/suppliers/services/suppliers-services.store';
import {getSuppliersServicesDataSource} from '@store/suppliers/services/suppliers-services.requests';

export class SuppliersServicesQuery {
  store = suppliersServicesStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  suppliersServices$ = getSuppliersServicesDataSource.data$();
  selectedSuppliersServices$ = this.store.pipe(
    selectManyByPredicate((suppliersServiceUI) => suppliersServiceUI.selected, {pluck: 'id', ref: UIEntitiesRef}),
  );

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const suppliersServicesQuery = new SuppliersServicesQuery();